import React from 'react';
import './App.css';
import photoBoothImg from './images/Photo Booth.jpeg';
import imgOne from './images/working/one.jpg';
import imgTwo from './images/working/two.jpeg';
import imgThree from './images/working/three.JPG';

const serviceDetails = [
  {
    img: imgTwo,
    title: 'Professional MC',
    bullets: [
      'FREE when you book our Coordination or Planning package',
      'Single Event: $600. Additional Events: $500 each.',
      'Up to 6 hours of MC Services with One Agenda Review Session!',
    ],
  },
  {
    img: imgOne,
    title: 'Wedding Coordination w/Free MC Services',
    bullets: [
      'Starting at $1,900/Event - Please contact us for a detailed quote',
      'Remove your stress. Let us handle the details starting 3 months in advance.',
      'Timeline Development for All Events, Vendor Communication, and More!',
    ],
  },
  {
    img: imgThree,
    title: 'Wedding Planning w/Free MC Services',
    bullets: [
      'Starting at $2,900/Event - Please contact us for a detailed quote',
      'Vendor selection, to budget management, to expert scheduling, we handle it all.',
      'From the first idea to the final send-off, we guide you every step of the way.',
    ],
  },
  {
    img: photoBoothImg,
    title: 'Photo Booth',
    bullets: [
      '$500/Event for Digitial Photo Booth for 3 Hours',
      '$650/Event for Unlimited prints & instant sharing, for 3 hours',
      'Back Drop, Props, and Custom Template Design Included for Free',
    ],
    className: 'photobooth-img',
    pdf: '/docs/2025%20Awaaz%20Photobooth%20Information%202024.pdf',
  },
];

function isMobile() {
  if (typeof window === 'undefined') return false;
  return window.innerWidth <= 900;
}

export default function LearnMore() {
  const [mobile, setMobile] = React.useState(isMobile());
  React.useEffect(() => {
    const listener = () => setMobile(isMobile());
    window.addEventListener('resize', listener);
    return () => window.removeEventListener('resize', listener);
  }, []);

  return (
    <div className="learn-more-root" style={{background:'#f7f5ec', minHeight:'100vh'}}>
      {/* Spacer to prevent content from being hidden by navbar (header) */}
      <div style={{height: 102, width:'100%'}}></div>
      <div className="learnmore-container" style={{maxWidth: 1020, margin:'0 auto', paddingTop: 14, paddingLeft: mobile ? 0 : 16, paddingRight: mobile ? 0 : 16}}>
        <h1 className="learnmore-title" style={{textAlign:'center', fontWeight:700, fontSize: mobile ? '1.25rem' : '2.25rem', marginBottom:mobile?18:44, marginTop:0, color:'#ac8a36', padding:'0 2vw'}}>
          Details & Pricing
        </h1>
        <div style={{display:'flex', justifyContent:'center', marginBottom:mobile?22:38}}>
          <button
            onClick={() => {
              const el = document.getElementById('faq-section');
              if (el) el.scrollIntoView({behavior:'smooth'});
            }}
            style={{
              background:'#fff', color:'#ac8a36', border:'2px solid #ac8a36', borderRadius: 23, padding:mobile?'10px 28px':'13px 54px', fontWeight:700, fontSize: mobile?'1.05rem':'1.2rem', cursor:'pointer', boxShadow:'0 1.5px 7px #dac36311', transition:'background 0.25s, color 0.25s, border-color 0.18s', outline:'none', marginTop: 0
            }}
          >
            Click here for Frequently Asked Questions
          </button>
        </div>
        {serviceDetails.map((svc, i) => {
          const rowStyle = mobile
            ? {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                marginBottom: 28,
                background: '#fff',
                borderRadius: 15,
                boxShadow: '0 1.5px 11px #dac36312, 0 1px 7px #dac36312',
                padding: '0',
                overflow: 'hidden',
                width: '90vw',
                maxWidth: 360,
                marginLeft: 'auto',
                marginRight: 'auto',
              }
            : {
                display: 'flex',
                flexDirection: i % 2 === 0 ? 'row' : 'row-reverse',
                alignItems: 'center',
                marginBottom: 52,
                background: '#fff',
                borderRadius: 24,
                boxShadow: '0 2px 22px #dac36322, 0 1px 7px #dac36322',
                padding: '0',
                overflow: 'hidden',
                minHeight: 240,
                transition: 'box-shadow 0.23s, border-color 0.2s, transform 0.19s, background 0.18s',
              };
          return (
            <div
              key={svc.title}
              className="learn-flex-row learn-card-modern"
              style={rowStyle}
            >
              <div className="learn-col-img" style={{
                flex: mobile ? 'none' : '0 0 290px',
                minWidth: mobile ? 'unset' : 170,
                maxWidth: mobile ? 'unset' : 340,
                display:'flex', alignItems:'center', justifyContent:'center', background:'#f2ede3',
                padding: mobile ? '14px 0 6px 0' : undefined
              }}>
                <img
                  src={svc.img}
                  alt={svc.title}
                  className={`service-img${svc.className ? ' ' + svc.className : ''}`}
                  style={{
                    width: mobile?'76vw':'97%',
                    maxWidth: mobile?'88vw':220,
                    maxHeight: mobile?130:180,
                    borderRadius:mobile?8:18,
                    objectFit:'cover',
                    margin: mobile?'0 auto 0 auto':'28px 0 28px 0',
                    boxShadow: mobile?'0 2px 8px #dac36323':'',
                    display:'block'
                  }}
                />
              </div>
              <div className="service-content" style={{
                width:'100%',
                padding: mobile ? '11px 2vw 19px 2vw' : '28px 38px 28px 38px',
                minWidth: 0,
                display:'flex',
                flexDirection:'column',
                justifyContent:'center',
                alignItems: 'center',
                textAlign: 'center',
              }}>
                <h3 style={{color:'#ac8a36', fontFamily:'Playfair Display, serif', fontSize: mobile ? '0.97rem':'1.29rem', marginBottom:mobile?7:15, marginTop:0, letterSpacing:0.01, padding:0}}>{svc.title}</h3>
                <ul style={{fontSize:mobile?'0.90rem':'1.08rem', color:'#222', marginTop:mobile?1:5, marginBottom:mobile?4:7, paddingLeft: 0, lineHeight:'1.77', listStylePosition:'inside', textAlign: 'center'}}>
                  {svc.bullets.map((item, idx) => <li key={idx} style={{marginBottom:mobile?6:9}}>{item}</li>)}
                </ul>
                {svc.pdf && (
                  <a href={svc.pdf} download className="learn-more-btn" style={{marginTop:mobile?10:22, fontSize:mobile?'1rem':'1.1rem', padding: mobile?'12px 26px':'13px 38px', border:'2.5px solid #d4af37', alignSelf:'center', textAlign:'center', background:'#e5e3d9', color:'#826b2e'}}>
                    Click here for detailed PDF
                  </a>
                )}
              </div>
            </div>
          );
        })}
        {/* FAQ Section */}
        <div id="faq-section" className="faq-section" style={{
          marginTop: 56,
          maxWidth: 1020,
          marginLeft: 'auto',
          marginRight: 'auto',
          padding: mobile ? '0 2vw' : '0 16px',
        }}>
          <h2 style={{textAlign:'center', color:'#ac8a36', marginBottom: 32, fontSize: mobile ? '1.12rem':'2rem', fontWeight: 700, letterSpacing: 0.2 }}>Frequently Asked Questions</h2>
          <div className="faq-list" style={{display:'flex', flexDirection:'column', gap: mobile ? 22 : 28}}>
            {[
              {
                q: 'Why should I choose Awaaz Events?',
                a: 'It is not the 10+ Years of Experience that seperates us, its how we work. We do not just "show up and coordinate", we work with your vendors in the months prior. We do not just show up and have someone else make the announcements, we move things forward by handling all announcements through our free MC Services. We are not just the coordinators, we are the energizers, updates, the helping hand for your special day. '
              },
              {
                q: 'I am thinking about having my friend be the MC, why should I hire you?',
                a: 'Ali, our MC, has had experience with crowd sizes upwords of 10,000 people. He knows how to control a crowd, energize them, and ensure everything is in order during the event. A lot of people choose family members since they are familiar with the couple, but 99% of the time, family members may be the perfect speaker during family game night, but tend to fumble when it comes to a live event. '
              },
              {
                q: 'Can you just show up and coordinate during the day of my event? I just need Day of Coordination, are you right for me?',
                a: 'Simply put, No. We do not believe in "Day of Coordination." Why? Because a wedding which has taken months, if not years, to plan should not be left to someone who is not familiar on the timeline, flow, vendors, and more. That is why our coordination starts 3 months in advance of your event. We will never show up to your event without any idea of what you have planned. '
              },
              {
                q: 'Is there a free consultation before booking?',
                a: 'Absolutely! We offer a complimentary consultation to understand your vision and explain how we can help.'
              },
              {
                q: 'Are you a one person show?',
                a: 'No - and that is what makes us different. When you hire our coordination or planning, we have a team of coordinators who are trained and experienced in the wedding industry. We have a team of people who are dedicated to making your event perfect.'
              },
              {
                q: 'How far in advance should I book?',
                a: 'For best availability, book at least 3-6 months in advance. But don’t hesitate to ask about last-minute bookings!'
              },
              {
                q: 'How do you price?',
                a: 'We price based off of the location and guest count. We have a team, and not just a single-person who shows up to take care of everything. If we have a larger event, we will hire more people to coordinate which effects pricing.'
              },
              {
                q: 'Are there travel fees for events outside the city?',
                a: 'Local travel is included. For events beyond our area zip code 22039, nominal travel fees may apply. We’ll provide details during your quote.'
              },
              {
                q: 'I found a cheaper quote, will you price match?',
                a: 'One promise we hold, is that we will never sacrifice our quality of work. Although there are great vendors out there, the way we ensure that a team is present at your event and MC Services are always included, our price is as competitive as possible.'
              },
              {
                q: 'Is your team experienced with cultural or multicultural events?',
                a: 'Yes! We have extensive experience with South Asian, fusion, and multicultural weddings and celebrations.'
              },
              {
                q: 'How do I get started?',
                a: 'Contact us through our website, email, or phone to schedule your complimentary consultation.'
              },
              
            ].map((faq, i) => (
              <div key={i} className="faq-item" style={{background:'#fff', borderRadius:18, boxShadow:'0 2px 12px #dac36320', padding: mobile?'18px 12px':'23px 32px', marginBottom:0}}>
                <div style={{fontWeight:700, fontSize: mobile ? '1.04rem' : '1.12rem', color:'#795c18', letterSpacing:0.04, marginBottom: 11}}>
                  {faq.q}
                </div>
                <div style={{color:'#222', fontWeight:400, fontSize: mobile ? '0.96rem' : '1.07rem', lineHeight:'1.7', marginBottom: 2}}>
                  {faq.a}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}